export default function (editor, opt = {}) {
  const c = opt;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const resposeTotalRecordsTrait = {
    type: 'text',
    label: 'Total Records Path',
    name: 'data-totalRecordsPath',
    value: '',
    placeholder: 'eg. data.totalRecords',
  };

  domc.addType('pagination-number', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          tagName: 'div',
          'custom-name': 'Pagination Number',
          icon: '<i class="wb webconnect-subtract"></i>',
          draggable: '.data-table', // Can be dropped only inside `data-table` elements
          droppable: true, // Can't drop other elements inside
          traits: [
            {
              type: 'text',
              label: 'Record Offset Key',
              name: 'data-offset-key',
              value: '',
              placeholder: 'eg. offset',
            },
            {
              type: 'text',
              label: 'Page Offset Key',
              name: 'data-page-offset-key',
              value: '',
              placeholder: 'eg. page',
            },
            {
              type: 'text',
              label: 'Records Per Page Key',
              name: 'data-limit-key',
              value: '',
              placeholder: 'eg. limit',
            },
            {
              type: 'checkbox',
              label: 'Show Page Dropdown',
              name: 'data-showPagePaginationDropdown',
              default: false,
            },
            {
              type: 'checkbox',
              label: 'Persist Pagination on Page Reload',
              name: 'data-persistPagination',
              default: false,
            },
            ...domc.getType('table').model.prototype.defaults.traits,
          ],
        },
        init() {
          let dataTable = this.closestType('data-table');
          const collectionFrom = dataTable.get('collectionFrom');

          if (collectionFrom && collectionFrom === 'externalAPIResponse') {
            this.addTrait(resposeTotalRecordsTrait, {
              at: this.getTraitIndex('data-persistPagination') + 1,
            });
          } else {
            this.removeTrait('data-totalRecordsPath');
          }
        },
      },

      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'pagination-number') {
            return {
              type: 'pagination-number',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init() {},
    }),
  });
}
